import * as React from "react";
import { FormHelperText } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectProps } from "@mui/material/Select";

import { ISelection } from "../../types";

import { AppSelectWrapper } from "./styles";

interface IProps extends Omit<SelectProps, "onChange"> {
  mode?: "dark" | "light";
  label?: string;
  options?: ISelection[];
  onChange?: (v: string | number) => void;
  helperText?: string;
}

const AppSelect: React.FC<IProps> = ({
  mode,
  options = [],
  onChange,
  error,
  helperText,
  label,
  value,
  ...props
}) => {
  return (
    <AppSelectWrapper mode={mode}>
      <FormControl error={error} variant="filled">
        <InputLabel error={error}>{label}</InputLabel>
        <Select
          MenuProps={{
            sx: {
              ".MuiPaper-root": {
                backgroundColor: mode === "dark" ? "#1E2430" : "#ffffff",
                marginTop: "4px",
                color: mode === "dark" ? "#fff" : "#0d0a2c",
                maxHeight: 250,
                borderRadius: "0 0 16px 16px",
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                padding: "8px 16px",
              },
              ".MuiList-root": {
                padding: "8px 0",
              },
              ".MuiMenuItem-root": {
                fontFamily: "'Manrope', sans-serif",
                fontSize: "12px",
                fontWeight: 400,
                letterSpacing: "0.06px",
                color: mode === "dark" ? "#fff" : "#0d0a2c",
                padding: "8px",
                borderRadius: "4px",
                marginBottom: "4px",
                "&:last-child": {
                  marginBottom: 0,
                },
                "&:hover": {
                  backgroundColor: mode === "dark" ? "#2B3544" : "#f0f4fa",
                },
                "&.Mui-selected": {
                  backgroundColor: mode === "dark" ? "#253041" : "#e3ecfb",
                  "&:hover": {
                    backgroundColor: mode === "dark" ? "#2B3544" : "#d6e4f7",
                  },
                },
              },
            },
          }}
          value={value}
          onChange={(event) => {
            if (
              onChange &&
              (typeof event.target.value === "string" ||
                typeof event.target.value === "number")
            ) {
              onChange(event.target.value);
            }
          }}
          {...props}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {String(value) === String(option.value) && (
                <svg
                  fill="none"
                  height="10"
                  style={{ marginRight: 8 }}
                  viewBox="0 0 12 10"
                  width="12"
                >
                  <path
                    d="M1 5L4.5 8.5L11 1.5"
                    stroke="#5087E7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  />
                </svg>
              )}
              {option.label}
            </MenuItem>
          ))}
        </Select>
        {helperText && (
          <FormHelperText error={error}>{helperText}</FormHelperText>
        )}
      </FormControl>
    </AppSelectWrapper>
  );
};

export default AppSelect;
